<template>
  <div id="SectionCompliance">
    <UIContainer class="SectionCompliance__container">
      <h2 class="SectionCompliance__title">
        Built for regulated disclosures and buyer assessments.
      </h2>

      <div
        class="SectionCompliance__marquee-container"
        style="--fade-left-size: 6rem; --fade-right-size: 6rem"
      >
        <div class="SectionCompliance__marquee">
          <div
            v-for="(logo, index) in [
              ...complianceLogos,
              ...complianceLogos,
              ...complianceLogos,
              ...complianceLogos,
            ]"
            :key="index"
            class="SectionCompliance__logo"
          >
            <img
              :src="logo.src"
              :alt="logo.name"
              class="SectionCompliance__logo-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import ecovadis from './assets/compliance/ecovadis.avif'
import ggp from './assets/compliance/ggp.avif'
import science from './assets/compliance/science.avif'
import tcfd from './assets/compliance/tcfd.avif'
import iso from './assets/compliance/iso.avif'

// Define compliance logos with their paths
const complianceLogos = ref([
  {
    name: 'Ecovadis',
    src: ecovadis,
  },
  {
    name: 'GGP',
    src: ggp,
  },
  {
    name: 'Science',
    src: science,
  },
  {
    name: 'TCFD',
    src: tcfd,
  },
  {
    name: 'ISO',
    src: iso,
  },
])
</script>

<style lang="scss" scoped>
#SectionCompliance {
  .SectionCompliance__container {
    padding: 2rem 1rem 2rem;

    @include md {
      padding: 2.5rem 1rem 4rem;
    }
  }

  .SectionCompliance__title {
    @include font-size-18px();
    font-weight: 600;
    color: $color-ui-gray-cool-600;
    text-align: center;
    margin-bottom: 2rem;
  }

  .SectionCompliance__marquee-container {
    overflow: hidden;
    margin-top: 1.5rem;
    width: 100%;
    position: relative;
    // Mask-based edge fades that reveal parent background
    --fade-left-size: 0rem;
    --fade-right-size: 0rem;
    -webkit-mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 1) var(--fade-left-size),
      rgba(0, 0, 0, 1) calc(100% - var(--fade-right-size)),
      rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 1) var(--fade-left-size),
      rgba(0, 0, 0, 1) calc(100% - var(--fade-right-size)),
      rgba(0, 0, 0, 0) 100%
    );
  }

  .SectionCompliance__marquee {
    display: flex;
    align-items: center;
    gap: 2rem;
    white-space: nowrap;
    animation: scroll-left 30s linear infinite;
    width: fit-content;

    @include md {
      gap: 3rem;
    }

    &:hover {
      animation-play-state: paused;
    }
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-35%);
    }
  }

  .SectionCompliance__logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
    margin-right: 2rem;

    @include md {
      margin-right: 3rem;
    }
  }

  .SectionCompliance__logo-image {
    max-height: 60px;
    max-width: 120px;
    width: auto;
    height: auto;
    object-fit: contain;

    @include md {
      max-height: 80px;
      max-width: 150px;
    }
  }
}
</style>
